export default __webpack_public_path__ + "static/metamask-28c9de38b0285b7f15960d8d9a28f6e9.png";